import { DownloadFile, enqueueSnackbar } from 'actions';

import {
	GetFailuresPacketRequest,
	SetFailurePacketValidInvalidRequest,
	GetFailurePacketDetailsRequest,
	SetFailurePacketDetailsRequest,
	AddPacketCommentRequest,
	ExportFailuresPacketRequest
} from '../requests/PacketRequest';

export const GET_FAILURES_PACKET = 'GET_FAILURES_PACKET';
export const GET_FAILURE_PACKET_DETAILS = 'GET_FAILURE_PACKET_DETAILS';
export const TOGGLE_PACKET_EDIT_FAILURE_DIALOG = 'TOGGLE_PACKET_EDIT_FAILURE_DIALOG';
export const SET_FORM_STATE = 'SET_FORM_STATE';

const onGetFailuresPacket = (value) => ({
	type: GET_FAILURES_PACKET,
	failures: value
});

const onTogglePacketEditFailureDialog = (visible, tableId, failureId) => ({
	type: TOGGLE_PACKET_EDIT_FAILURE_DIALOG,
	visible,
	tableId,
	failureId
});

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onGetFailurePacketDetails = (value) => ({
	type: GET_FAILURE_PACKET_DETAILS,
	failure: value
});

export const GetFailuresPacket = (userId, role) => async (dispatch) => {
	await GetFailuresPacketRequest(userId, role).then(response => {
		dispatch(onGetFailuresPacket(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetFailurePacketValidInvalid = (userId, id) => async (dispatch) => {
	await SetFailurePacketValidInvalidRequest(userId, id).then(response => {
		// dispatch(onGetFailuresVoice(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const TogglePacketEditFailureDialog = (visible, tableId, failureId) => (dispatch) => {
	dispatch(onTogglePacketEditFailureDialog(visible, tableId, failureId));
};

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const GetFailurePacketDetails = (id, userId) => async (dispatch) => {
	await GetFailurePacketDetailsRequest(id, userId).then(response => {
		dispatch(onGetFailurePacketDetails(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetFailurePacketDetails = (failure, userId) => async (dispatch) => {
	await SetFailurePacketDetailsRequest(failure, userId).then(response => {
		// dispatch(onGetFailureVoiceDetails(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const AddPacketComment = (id, userId, comment) => async (dispatch) => {
	await AddPacketCommentRequest(id, userId, comment).then(response => {
		dispatch(GetFailurePacketDetails(id));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ExportFailuresPacket = (userId, role) => async (dispatch) => {
	await ExportFailuresPacketRequest(userId, role).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
